import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { TextCutter } from '@anytag/shared-atoms';
import { PostDetailsType, SupportedSocialMediaType } from '@anytag/shared-types';

export interface CommentsProps {
  className?: string;
  comments?: PostDetailsType['commentsContent'];
  socialMedia?: keyof typeof SupportedSocialMediaType;
}

export const Comments = ({ comments = [], className, socialMedia }: CommentsProps) => {
  const { t } = useTranslation();

  return comments.length > 0 ? (
    <div className={cn('flex-[1_1_0] overflow-hidden rounded-sm bg-light-gray', className)}>
      <p className="px-2 pt-2 text-xs font-normal text-black-60">
        {t(socialMedia === SupportedSocialMediaType.INSTAGRAM_STORY ? 'General.Replies' : 'General.Comments')}
      </p>

      <div className="h-[calc(100%-2rem)] flex-[1_1_0] overflow-y-auto">
        {comments.map((comment, index) => (
          <div key={`comment-${index}`} className="flex p-2">
            <TextCutter text={comment.username || t('no username')} className="w-18 text-sm font-semibold" />
            <p className="ml-2.5 w-fit text-sm break-all text-black-90">{comment.content}</p>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};
